import React from 'react';
import { useLocation } from 'react-router';
import {
  RadioGroup,
  Box,
  FormControlLabel,
  Radio,
  makeStyles,
  InputLabel
} from '@material-ui/core';
import { CapaQuotationUserBizType } from '@generated/graphql';
import { colorSet } from '@components/Provider';
import { CustomizedTypography } from '@components/Customized';

interface BizTypeRadioGroupProps {
  bizType: CapaQuotationUserBizType;
  setBizType: (bizType: CapaQuotationUserBizType) => void;
}

const BizTypeRadioGroup: React.FC<BizTypeRadioGroupProps> = ({
  bizType,
  setBizType
}) => {
  const { radioBox, radioGroupStyle } = useStyles();
  const { pathname } = useLocation();
  const isSignUp = pathname.includes('signup');

  return (
    <Box className={radioBox}>
      <InputLabel htmlFor="bizType">
        <CustomizedTypography
          variant="body1"
          fontWeight="700"
          color="textPrimary"
        >
          사업자 여부
        </CustomizedTypography>
      </InputLabel>
      <RadioGroup
        className={radioGroupStyle}
        id="bizType"
        defaultValue={CapaQuotationUserBizType.Biz}
      >
        <Box
          className={bizType === CapaQuotationUserBizType.Biz ? 'selected' : ''}
          onClick={() => {
            setBizType(CapaQuotationUserBizType.Biz);
          }}
        >
          <FormControlLabel
            label={
              <CustomizedTypography variant="subtitle2" color="textPrimary">
                사업자등록번호{isSignUp ? '가 있습니다.' : ' 있음'}
              </CustomizedTypography>
            }
            labelPlacement="end"
            control={
              <Radio
                color="primary"
                checked={bizType === CapaQuotationUserBizType.Biz}
                value={CapaQuotationUserBizType.Biz}
                onChange={(e) =>
                  setBizType(e.currentTarget.value as CapaQuotationUserBizType)
                }
              />
            }
          />
        </Box>

        <Box
          className={bizType !== CapaQuotationUserBizType.Biz ? 'selected' : ''}
          onClick={() => {
            setBizType(CapaQuotationUserBizType.Individual);
          }}
        >
          <FormControlLabel
            label={
              <CustomizedTypography variant="subtitle2" color="textPrimary">
                사업자등록번호{isSignUp ? '가 없습니다.' : ' 없음'}
              </CustomizedTypography>
            }
            labelPlacement="end"
            control={
              <Radio
                color="primary"
                value={CapaQuotationUserBizType.Individual}
                checked={bizType !== CapaQuotationUserBizType.Biz}
                onChange={(e) =>
                  setBizType(e.currentTarget.value as CapaQuotationUserBizType)
                }
              />
            }
          />
        </Box>
      </RadioGroup>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  radioBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  radioGroupStyle: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: '8px',
    '& .MuiBox-root': {
      '& .MuiFormControlLabel-root': {
        display: 'flex',
        gap: '8px',
        margin: 0
      },
      border: `1px solid ${colorSet.gray400}`,
      borderRadius: '4px',
      padding: '8px 12px',
      flex: 1,
      '&:hover': {
        cursor: 'pointer'
      },
      '&.selected': {
        borderColor: colorSet.primary500,
        transition: 'all 0.2s ease-in-out'
      }
    },
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column'
    }
  }
}));

export default BizTypeRadioGroup;
